'use strict';

export default class VZAccordion extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.activeClass = 'is-open';

        this.accordion = this.querySelector('.accordion');
        this.accordionItem = this.accordion.querySelector('.js-accordion-item');
        this.accordionButton = this.accordion.querySelector('.js-accordion-button');
        this.accordionContent = this.accordion.querySelector('.js-accordion-content');

        this.accordionButton.addEventListener('click', this.onClick.bind(this));
    }

    onClick() {
        this.toggleClasses();
    }

    toggleClasses() {
        if (this.accordionButton.getAttribute('aria-expanded') === 'true') {
            this.accordionItem.classList.add(this.activeClass);
        } else {
            this.accordionItem.classList.remove(this.activeClass);
        }
    }
}

if (!window.customElements.get('vz-accordion')) {
    window.customElements.define('vz-accordion', VZAccordion);
}
